import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "text-center" }

import { useCheckout } from '@/storecontext/checkout/useCheckout';
import { onUnmounted } from 'vue';
import { useBlockLabels } from '@/shared/content/blocks/helpers/block-labels.plugin';


export default /*#__PURE__*/_defineComponent({
  __name: 'CheckoutPaymentDeliveryDateChanged',
  setup(__props) {

const labels = useBlockLabels();
const { setEarliestDeliveryDateChanged, setIsPaymentReady } = useCheckout();

onUnmounted(() => {
    setEarliestDeliveryDateChanged(false);
    setIsPaymentReady(false);
});

const reloadCheckoutPage = (): void => {
    setEarliestDeliveryDateChanged(false);
    setIsPaymentReady(false);
    setTimeout(() => window.location.replace(window.location.href.split('?')[0]), 300);
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, _toDisplayString(_unref(labels).earliestDeliveryDateChangedText), 1),
    _createElementVNode("button", {
      type: "button",
      class: "c-button c-button--primary flex flex-nowrap items-center mx-auto mt-x6",
      onClick: reloadCheckoutPage
    }, _toDisplayString(_unref(labels).earliestDeliveryChangedButton), 1)
  ]))
}
}

})